import './projets.scss';
import { Splide } from '@splidejs/splide';

(($) => {
    function initProjetsSlider() {

        const sliderProjets = new Splide( '.section-projets .splide', {
            type   : 'loop',
            gap : 32,
            perPage: 3,
            perMove: 1,
            breakpoints: {
                1023: {
                    gap: 10,
                },
                850: {
                    perPage: 2
                },
                580: {
                    perPage: 1
                }
            }
        });

        sliderProjets.mount();
    }
    if ($("body").hasClass("wp-admin")) {
        $(document).on("initProjetsSlider", initProjetsSlider);
    } else {
        $(document).ready(initProjetsSlider);
    }
})(jQuery);